export default __webpack_public_path__ + "static/decorist-4-c-e48260a63933b022677d4ee980c1cf4b.webp";